import React from 'react';
import { withRouter } from 'react-router-dom';
import ContabilidadeLogo from './img/contabilidade.png';
import EstoqueLogo from './img/estoque.png';
import RelatorioLogo from './img/relatorio.png';
import GerenciaLogo from './img/gerencia.png';

class Relatorios extends React.Component {

    constructor() {

        super();

        this.contabilidade = this.contabilidade.bind(this);
        this.fluxoEstoque = this.fluxoEstoque.bind(this);
        this.resumoAnual = this.resumoAnual.bind(this);
        this.gerencial = this.gerencial.bind(this);

    }

    contabilidade() {
        this.props.history.push("/relatoriocontabilidade");
    }

    fluxoEstoque() {
        this.props.history.push("/relatorioestoque");
    }

    resumoAnual() {
        this.props.history.push("/resumoanual");
    }

    gerencial() {
        this.props.history.push("/relatoriogerencial");
    }

    componentDidMount() {

        if (localStorage.roleRelatorios === "nenhuma") {
            window.location.href = "/home";
        }

    }

    render() {
        return(
            <div>
                <h1 id="relatorios-title">Relatórios</h1>
                <br /><br /><br /><br />
                <ul>
                    { localStorage.roleRelatorios !== "nenhuma" &&
                        <li>
                            <p id="relatorios-menu" onClick={ this.contabilidade }>
                                <img src={ContabilidadeLogo} alt="Contabilidade" />
                                <p>Relatório de Contabilidade</p>
                            </p>
                        </li> }
                    { (localStorage.roleRelatorios === "ler" || localStorage.roleRelatorios === "escrever") &&
                        <li>
                            <p id="relatorios-menu" onClick={ this.fluxoEstoque }>
                                <img src={EstoqueLogo} alt="Fluxo de Estoque" />
                                <p>Relatório de Fluxo de Estoque</p>
                            </p>
                        </li> }
                    { (localStorage.roleRelatorios === "ler" || localStorage.roleRelatorios === "escrever") &&
                    <li>
                        <p id="relatorios-menu" onClick={ this.resumoAnual }>
                            <img src={RelatorioLogo} alt="Resumo Anual" />
                            <p>Resumo Anual</p>
                        </p>
                    </li> }
                    { (localStorage.roleRelatorios === "ler" || localStorage.roleRelatorios === "escrever") &&
                    <li>
                        <p id="relatorios-menu" onClick={ this.gerencial }>
                            <img src={GerenciaLogo} alt="Relatório Gerencial" />
                            <p>Relatório Gerencial</p>
                        </p>
                    </li> }
                </ul>
            </div>
        );
    }

}

export default withRouter(Relatorios);

